import React from 'react';
import { Link } from 'react-router-dom';
import type { SectionLink } from 'src/models/section-links';
import styled, { css } from 'styled-components';

import { mediaQueries } from 'shared/styles';
import { SidebarIcon } from 'src/components/sidebar/icon';
import { Tag } from 'src/dispensary-admin/customize/customize';

type SidebarLinkProps = Pick<SectionLink, 'badge' | 'icon' | 'label' | 'status' | 'to'> & {
  active?: boolean;
  onClick?: () => void;
};

export function SidebarLink(props: SidebarLinkProps): JSX.Element {
  const { active, badge, icon, label, to, status, onClick } = props;

  return (
    <StyledLink $active={!!active} to={to} onClick={onClick}>
      {icon && <SidebarIcon icon={icon} active={active} />}

      <Label>
        {label}
        {badge && <Badge size={Number(badge) > 99 ? 'lg' : 'sm'}>{badge}</Badge>}
        {status && <Status>{status}</Status>}
      </Label>
    </StyledLink>
  );
}

const Label = styled.span`
  display: inline-block;
  font-weight: bold;
  font-size: 14px;
  margin-left: 18px;

  @media ${mediaQueries.desktop} {
    font-size: 18px;
  }
`;

const StyledLink = styled(Link)<{ $active: boolean }>`
  align-items: center;
  display: flex;
  line-height: 42px;
  color: #f1e8d6;
  cursor: pointer;
  padding-left: 38px;
  position: relative;

  @media ${mediaQueries.desktop} {
    line-height: 65px;
    padding-left: 56px;
  }

  @media ${mediaQueries.largePhone} {
    line-height: 54px;
    padding-left: 55px;
    margin: 5px 0;
  }

  &:hover {
    color: #ffffff;
    text-decoration: none !important;

    img {
      filter: brightness(0) invert(1);
    }
  }

  ${(props) =>
    props.$active &&
    css`
      background-color: #00261a;
      color: #f1e8d6;
      @media ${mediaQueries.desktop} {
        color: #f1e8d6;
      }
    `}
`;

const Badge = styled.div<{ size: 'lg' | 'sm' }>`
  background-color: #eb3f50;
  border-radius: ${({ size }) => (size === 'lg' ? '10px' : '100%')};
  color: #ffffff;
  display: inline-block;
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  margin-left: 10px;
  padding-right: 1px;
  text-align: center;
  width: ${({ size }) => (size === 'lg' ? '33px' : '20px')};
`;

const Status = styled(Tag)`
  background: linear-gradient(106.91deg, #ff3e51 7.85%, #4862f0 88.18%);
  color: #fff;
  bottom: 0;
  margin: auto 8px;
  top: 0;
  width: auto;
`;
